<template>
  <div class="am-modal am-modal-alert" tabindex="-1" id="my-alert">
    <div class="am-modal-dialog">
      <div class="am-modal-bd">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'alert',
    props: {
      showModal: {
        type: Boolean
      }
    },

    watch: {
      showModal: function (newValue) {
        if (newValue) {
          $('#my-alert').modal('open')
          $('#my-alert').on('closed.modal.amui', () => {
            this.$emit('update:showModal', false)
          })
        }
      }
    },
    methods: {
      close () {
        if (this.listshow === this.listall) {
          this.$emit('update:listshow', this.count)
          this.str = '点击显示更多'
        } else if (this.listshow + this.count > this.listall) {
          this.$emit('update:listshow', this.listall)
          this.str = '收起列表'
        } else {
          this.$emit('update:listshow', this.listshow + this.count)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #my-alert
    .am-modal-dialog
      border-radius 5px
      .am-modal-bd
        color #c81414
        font-size 15px
        border-radius 5px
</style>



// WEBPACK FOOTER //
// alert.vue?7bb43c26